export const SECURITY_CODE = {
  SECURITY_CODE: "تغيير رقم الجوال",
  ENTER_SECURITY_CODE: "من فضلك أدخل رمز الأمان الخاص بحسابك",
  CHANGE_SECURITY_CODE: "تغيير رمز الأمان",
  ENTER_CURRENT_SECURITY_CODE: "أدخــــــل رمـــــــز الأمان الحالي",
  SUCCESSFULLY_SET: "تم إعادة تعيين رمز الأمان بنجاح",
};

export const ALERT_MESSAGES = {
  PIN_VERIFIED: "تم التحقق من الرمز السري",
  PIN_VERIFICATION_FAILED: "فشل التحقق من رقم التعريف الشخصي",
  PIN_CHANGED: "تغير دبوس",
  UPDATE_FAILED: "فشل التحديث",
};

export const BUTTON = {
  EMPHASIS: "تأكيد",
  TRACKING: "متابعة",
};
